
import React, { useState, useEffect } from 'react';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs';
import { LoginForm } from '@/components/auth/LoginForm';
import { SignupForm } from '@/components/auth/SignupForm';
import PageLayout from '@/components/Layout/PageLayout';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserSession } from '@/hooks/useUserSession';

const AuthPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('login');
  const { user, isLoading } = useUserSession();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || (user?.role ? `/${user.role}` : '/');

  useEffect(() => {
    if (!isLoading && user && location.pathname === '/auth') {
      const rolePath = user.role ? `/${user.role}` : '/';
      navigate(rolePath, { replace: true });
    }
  }, [isLoading, user, location.pathname, navigate]);
  

  if (isLoading) return null;

  return (
    <PageLayout>
      <div className="container mx-auto py-12 px-4">
        <div className="max-w-md mx-auto">
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-bold">Welcome to Health Portal</CardTitle>
              <CardDescription>
                Sign in to your account or register as a new user
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Tabs value={activeTab} onValueChange={setActiveTab}>
                <TabsList className="grid w-full grid-cols-2">
                  <TabsTrigger value="login">Login</TabsTrigger>
                  <TabsTrigger value="signup">Sign Up</TabsTrigger>
                </TabsList>
                <TabsContent value="login" className="mt-4">
                  <LoginForm />
                </TabsContent>
                <TabsContent value="signup" className="mt-4">
                  <SignupForm />
                </TabsContent>
              </Tabs>
            </CardContent>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
};

export default AuthPage;
